import React from 'react'
import { Link } from 'react-router-dom'

import cpu from '../../assets/images/icon/cpu.png'
import vga from '../../assets/images/icon/vag.png'
import caseCoputer from '../../assets/images/icon/computer-tower.png'
import fan from '../../assets/images/icon/fan-computer.png'
import hdd from '../../assets/images/icon/hdd.png'
import monitor from '../../assets/images/icon/monitor.png'
import motherboard from '../../assets/images/icon/motherboard.png'
import powerSupply from '../../assets/images/icon/power-supply.png'
import ram from '../../assets/images/icon/ram.png'
import ssd from '../../assets/images/icon/ssd.png'
import wifi from '../../assets/images/icon/wifi-router.png'
import bg from '../../assets/images/product/fan.png'
function MegaMenu() {
    return (
        <>
            <div className="dropdown-menu mega-menu col-lg-7 pt-4 " aria-labelledby="navbarDropdown">
                <ul className="row overflow-y">
                    <li className="col-sm-6 col-lg-2 ">
                        <h4>دسته بندی 1</h4>
                        <ul>
                            <li>
                                <Link className="dropitems p-0 py-2" to='/store'>
                                    <img src={cpu} alt="پردازنده" className='dropSvg img-fluid' />
                                    <span>پردازنده</span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropitems p-0 py-2 " to='/store'>
                                    <img src={vga} alt="کارت گرافیک " className='dropSvg img-fluid' />
                                    <span>کارت گرافیک </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropitems p-0 py-2 " to='/store'>
                                    <img src={motherboard} alt=" مادربرد " className='dropSvg img-fluid' />
                                    <span> مادربرد </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropitems p-0 py-2 " to='/store'>
                                    <img src={ram} alt=" رم " className='dropSvg img-fluid' />
                                    <span> رم </span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li className="col-sm-6 col-lg-2">
                        <h4> دسته بندی 2</h4>
                        <ul>
                            <li>
                                <Link className="dropitems p-0 py-2 " to='/store'>
                                    <img src={powerSupply} alt=" منبع تغذیه  " className='dropSvg img-fluid' />
                                    <span> منبع تغذیه  </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropitems p-0 py-2 " to='/store'>
                                    <img src={monitor} alt=" مانیتور " className='dropSvg img-fluid' />
                                    <span> مانیتور </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropitems p-0 py-2 " to='/store'>
                                    <img src={caseCoputer} alt=" کیس " className='dropSvg img-fluid' />
                                    <span> کیس </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropitems p-0 py-2 " to='/store'>
                                    <img src={hdd} alt=" هارد " className='dropSvg img-fluid' />
                                    <span> هارد </span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li className="col-sm-6 col-lg-2">
                        <h4> دسته بندی 3</h4>
                        <ul>
                            <li>
                                <Link className="dropitems p-0 py-2 " to='/store'>
                                    <img src={ssd} alt=" اس اس دی " className='dropSvg img-fluid' />
                                    <span> اس اس دی </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropitems p-0 py-2 " to='/store'>
                                    <img src={fan} alt=" خنک کننده  " className='dropSvg img-fluid' />
                                    <span> خنک کننده  </span>
                                </Link>
                            </li>
                            <li>
                                <Link className="dropitems p-0 py-2 " to='/store'>
                                    <img src={wifi} alt=" لوازم جانبی " className='dropSvg img-fluid' />
                                    <span> لوازم جانبی </span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <div className="col-sm-6">
                        <figure>
                            <img src={bg} className='img-fluid bdrs20' alt="" />
                        </figure>
                    </div>
                </ul>
            </div>
        </>
    )
}

export default MegaMenu